import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';

type TagProps = {
  text: string;
  color: string;
  borderColor: string;
  minWidth?: string;
  clickable?: boolean;
  handleClick?: () => void;
};
const Tag: React.FC<TagProps> = (props) => {
  return (
    <Box
      sx={{
        px: '8px',
        textAlign: 'center',
        minWidth: `${props.minWidth ? props.minWidth : 'auto'}`,
        height: '22px',
        borderRadius: '4px',
        border: `1px solid ${props.borderColor}`,
        cursor: `${props.clickable ? 'pointer' : 'default'}`,
      }}
      onClick={props.handleClick}
    >
      <Typography color={props.color}>
        {props.text}
      </Typography>
    </Box>
  );
};

export default Tag;
